import React, { forwardRef, useState, useImperativeHandle } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

import { Transition } from "..";

const ConfirmDelete = forwardRef((props, ref) => {
  const {
    children,
    dialogName,
    dialogTitle,
    dialogText,
    dialogConfirmedCallback,
  } = props;

  const [open, setOpen] = useState(false);

  const handleModalOpen = () => setOpen(true);

  const handleModalClose = () => setOpen(false);

  useImperativeHandle(ref, () => ({
    handleModalOpen: () => handleModalOpen(),
    handleModalClose: () => handleModalClose(),
  }));

  const handleDialogConfirmed = () => {
    handleModalClose();
    dialogConfirmedCallback();
  };

  return (
    <React.Fragment>
      {children}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleModalClose}
        aria-labelledby={`${dialogName}-dialog-title`}
        aria-describedby={`${dialogName}-dialog-description`}
      >
        <DialogTitle id={`${dialogName}-dialog-title`}>
          {dialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id={`${dialogName}-dialog-description`}>
            {dialogText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose} size="small">
            Cancel
          </Button>
          <Button
            onClick={handleDialogConfirmed}
            size="small"
            variant="contained"
            color="primary"
          >
            Remove
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
});

export default ConfirmDelete;



// WEBPACK FOOTER //
// ./src/components/ConfirmDelete/index.jsx